module.exports = __webpack_public_path__ + "static/media/Lady Robot.8ceac568.jpg";